import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AwsLexService {

    API_LEX: string = `${environment.URL}`;
    LAMBDA_FUNCTION_URL: string = `${environment.LAMBDA_FUNCTION_URL}`;

    constructor(private readonly httpClient: HttpClient) {}

    async sendLex2(Settings: any) {

        const url = this.API_LEX;
        let _data: any

        try {
          const result$ = this.httpClient.post(url, Settings);
           _data = await lastValueFrom(result$);
        } catch (error) {
          console.log(error)
        }


        return _data;
    }

    async uploadFile(fileName:any, sessionId:any, fileContent:any){
      const url = this.LAMBDA_FUNCTION_URL;
      let body = {fileName:fileName, sessionId:sessionId,content:fileContent};
      let _data: any
      try {
        const result$ = this.httpClient.post(url,JSON.stringify(body))
        _data = await lastValueFrom(result$);

      } catch (error) {
        console.log(error)
      }

      return _data;
    }
}
